import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import { fetchUsuario, getUsuario } from '../Components/user';
import TitleMeta from '../Components/TitleMeta/TitleMeta';

export default function MainLayout() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario(); // Llama a la función para obtener datos del usuario
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    // Redirigir según rol cuando se carga el usuario
    useEffect(() => {
        if (!loading && usuarioLegued?.idUsuario && usuarioLegued?.rol) {
            // Definir rutas por defecto según rol
            const rutasPorRol = {
                'terapeuta': '/dashboard/turnos',
                'secretaria': '/dashboard/turnos',
                'coord_ceseco': '/dashboard',
                'coord_programa': '/dashboard/citas',
                'admin': '/dashboard',
                'direccion': '/dashboard'
            };

            const rutaDestino = rutasPorRol[usuarioLegued.rol];

            // Redirigir si estamos en la ruta base /dashboard o /
            if (rutaDestino && (location.pathname === '/dashboard' || location.pathname === '/' || location.pathname === '/dashboard/')) {
                navigate(rutaDestino);
            }
        }
    }, [loading, usuarioLegued, navigate, location.pathname]);

    return (
        <div>
            <TitleMeta />
            {loading ? (
                <Spiner />
            ) : usuarioLegued?.idUsuario ? (
                <>
                    {["admin", "secretaria", "terapeuta", "coord_programa", "coord_ceseco", "direccion"].includes(usuarioLegued?.rol) ? (
                        <Outlet />
                    ) : (
                        <Auth />
                    )}
                </>
            ) : (
                <Auth />
            )}
        </div>
    );
}
